import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import { Marquee, Stats, Services, Process, Gallery } from "@/components/site/Sections";
import LeyardSection from "@/components/site/LeyardSection";
import Testimonials from "@/components/site/Testimonials";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function Landing() {
  return (
    <div className="relative z-[2] bg-[#050505]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Stats />
      <LeyardSection />
      <Services />
      <Process />
      <Gallery />
      <Testimonials />
      <QuoteForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
